import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlocks: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="blocks, integration, apps"><path d="M10.25 20.25V7.25H3.75V13.75M3.75 13.75H16.75V20.25H3.75V13.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 3.75H13.75V10.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlocks;
